import { businessLines } from 'data/notification';
const servicesItems = [{
    id: 1,
    icon: "zicu",
    name: "商家自促",
    desc: "精准投放，稳定拉新",
    to: "createSelfPromotion"
},
{
    id: 2,
    icon: "app",
    name: "手机App",
    desc: "快捷便携，及时处理",
    url: "//sj.qq.com/myapp/detail.htm?apkName=com.meituan.tripBizApp"
},
{
    id: 3,
    icon: "comment",
    name: "评论管理",
    desc: "维护客情，提升服务",
    to: "reviewlist"
},
{
    id: 4,
    icon: "datacenter",
    name: "数据分析",
    desc: "指标监控，销量提升",
    to: "operatingData"
}
]

const BizLineServiceItemsConfig = {
    4: [0, 1, 3],
    3: [0, 1, 2, 3]
};

const getBizLineInfoCacheKeyPrefix = 'getBizLineInfo';

function getBizLineInfo(bizLineId) {
    let key = getBizLineInfoCacheKeyPrefix + bizLineId;
    if (caches[key]) {
        return caches[key];
    }
    let bizLineInfo = bizLines.find((bizLine) => {
        return bizLine.bizLineId === bizLineId;
    });
    if (!bizLineInfo) {
        console.error('can not find the target bizlineinfo');
    }
    caches[key] = bizLineInfo;
    return bizLineInfo;
}

import { caches } from 'utils/caches';
import { bizLines } from 'config/common';
const getServiceItemsCacheKeyPrefix = "getServiceItems";

export const getServiceItems = function(bizLineId) {
    let key = getServiceItemsCacheKeyPrefix + bizLineId;
    if (caches[key]) {
        return caches[key];
    } else {
        let serviceItems = [];
        if (bizLines && bizLines.length) {
            let bizLineInfo = getBizLineInfo(bizLineId);
            if (!bizLineInfo) {
                console.error('can not find the bizline')
                return serviceItems;
            }
            let config = BizLineServiceItemsConfig[bizLineId] || [];
            serviceItems = servicesItems.filter((item, index) => {
                return config.includes(index);
            }).map((item) => {
                return Object.assign({}, item);
            });
            serviceItems.forEach((item) => {
                if (typeof item.to === 'string') {
                    item.to = bizLineInfo.value + item.to;
                } else if (typeof item.to === 'object') {
                    item.to = item.to[bizLineId];
                }
                if (typeof item.url === 'string') {
                    item.url = item.url.replace('${bizLineId}', bizLineId);
                    item.url = item.url.replace('${bizLineValue}', bizLineInfo.value);
                } else if (typeof item.url === 'object') {
                    item.url = item.url[bizLineId];
                }
            });
        } else {
            console.error('no bizlines found!');
        }
        caches[key] = serviceItems;
        return serviceItems;
    }
};

export const processServiceItem = function(item, router) {
    if (item.to) {
        router.push({ name: item.to });
        return;
    }
    if (item.url) {
        window.open(item.url, "_blank");
    }
};

export const openNoticeDetail = function(id) {
    window.open(window.location.pathname + `#/announce/${id}`, '_blank');
}

const xgxyRouteNamePostfix = 'academy';
const gzzxRouteNamePostfix = 'policyrule';
const ptgzRouteNamePrefix = 'broadcast';

export const moreNotices = function(type, bizLineId, router) {
    let bizLineInfo = getBizLineInfo(bizLineId);
    let ptgzRouteInfo = businessLines.find((bizLine) => { return bizLine.bizLineId === bizLineId; });
    let routeName = '';
    switch (type.toString()) {
        case '5':
            routeName = bizLineInfo.value + xgxyRouteNamePostfix;
            break;
        case '10':
            routeName = bizLineInfo.value + gzzxRouteNamePostfix;
            break;
        case '3':
            routeName = ptgzRouteNamePrefix + ptgzRouteInfo.value;
            break;
        default:
            break;
    }
    if (routeName) {
        router.push({ name: routeName });
    }
}

const createSelfPromotionPostfix = 'createSelfPromotion'

export const toCreateSelfPromotion = function(bizLineId, router) {
    let bizLineInfo = getBizLineInfo(bizLineId);
    router.push({ name: bizLineInfo.value + createSelfPromotionPostfix });
}

export const getDefaultData = function() {
    return {
        serviceItems: [],
        activeItems: [],
        notices: [],
        rules: [],
        courses: [],
        bizLineIdNum: null,
        hasServiceCard: false,
        bannerTexts: [],
        bannerImgs: [],
        topNotices: [],
        midNotices: []
    };
}


// WEBPACK FOOTER //
// ./src/components/nhomepage/utils.js